import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useState } from "react";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IModal } from "./QualityControle"
import { Fetch } from "../../shared/Fetch";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export interface IQualityControleList {
    id?: number,
    call_Duration?: number,
    call_Quality?: string,
    call_Type?: string,
    confidence_Level?: string,
    initiator_Entity?: string,
    initiator_Type?: string,
    point_Of_Contact?: string,
    points_Discussed?: string,
    receiver_Entity?: string,
    receiver_Name?: string,
    receiver_Type?: string,
    subject?: string,
    voice_Pitch?: string,
    added_By?: string,
    updated_By?: string,
    added_On?: Date,
    updated_On?: Date,
    audio_Path?: string,
    is_Verified?: boolean,
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const [showAudioModal, setShowAudioModal] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });

    const openNew = () => {
        props.setModal({ open: true, singleData: {} });
    };
    const leftToolbarTemplate = () => {
        return (
            props.permissions.is_Create ?
                <React.Fragment>
                    <div className="my-2">
                        <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    </div>
                </React.Fragment> : ''
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("QualityControle", "GET", null, "", props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    };

    const onDownloadCallRecording = async (data: IQualityControleList) => {
        setShowAudioModal({
            singleData: {
                audio_Path: data.audio_Path,
                id: data.id,
            }, open: true
        });
    };

    const playCallRecording = (data: IQualityControleList) => {

        return <>
            <Button icon="pi pi-play text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => onDownloadCallRecording(data)} />
        </>
    };

    const openEditSub = (data: IQualityControleList) => {
        props.setModal({ singleData: data, open: true });
    }

    const Action = (rowData: IQualityControleList) => {
        return <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEditSub(rowData)} />
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

        const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        const DateFormat = loginObj?.date_Format
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                value={tableData.tableData}
                loading={tableData.loading}
                dataKey="id"
            >
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                <Column field="call_Type" header="Call Type" />
                <Column field="initiator_Type" header="Initiator Type" />
                <Column field="initiator_Entity" header="Initiator Entity" body={(rowData) => <p>{rowData.initiator_Entity || "-"}</p>} />
                <Column field="point_Of_Contact" header="Point Of Contact" />
                <Column field="receiver_Type" header="Receiver Type" />
                <Column field="receiver_Entity" header="Receiver Entity" body={(rowData) => <p>{rowData.receiver_Entity || "-"}</p>} />
                <Column field="receiver_Name" header="Receiver Name" />
                <Column field="call_Duration" header="Call Duration (minutes)" />
                <Column field="subject" header="Subject" />
                <Column field="points_Discussed" header="Points Discussed" />
                <Column field="call_Quality" header="Call Quality" />
                <Column field="confidence_Level" header="Confidence Level" />
                <Column field="voice_Pitch" header="Voice & Pitch" />
                <Column field="added_By" header="Added By" />
                {/* <Column field="added_On" header="Added On" body={(rowData: IQualityControleList) => {
                    let date;
                    if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<>{date}</>);
                }} /> */}
                <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate( rowData.added_On, "dd/MM/yyyy", DateFormat)}/>
                <Column header="Play Recording" body={playCallRecording} />
                <Column field="updated_By" header="Updated By" />
                {/* <Column field="updated_On" header="Updated On" body={(rowData: IQualityControleList) => {
                    let date;
                    if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<>{date}</>);
                }} /> */}
                 <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, 'dd/MM/yyyy', DateFormat) } />
                <Column field="" header="Action" body={Action} />
            </DataTable>
            <Dialog visible={showAudioModal.open} style={{ width: '50vw' }} header="Play Recording" modal className="p-fluid" onHide={() => setShowAudioModal({ singleData: {}, open: false })}>

                {showAudioModal.open && showAudioModal.singleData.audio_Path && <div>
                    <audio controls preload="auto">
                        <source
                            src={`https://localhost:58345/api/QualityControle/streamAudio?pathName=${encodeURIComponent(showAudioModal.singleData.audio_Path)}&id=${showAudioModal.singleData?.id}`}
                            type="audio/mpeg"
                        />
                        Your browser does not support the audio element.
                    </audio>
                </div>}
            </Dialog>
        </>
    );
}